import createIcon from '../../createIcon';

/**
 * @component @name Signpost
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMgMTBIMThMMjEgN0wxOCA0SDEzVjJIMTFWNEg0VjEwSDExVjEySDZMMyAxNUw2IDE4SDExVjIySDEzVjE4SDIwVjEySDEzVjEwWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Signpost = createIcon('Signpost', [
  [
    'path',
    {
      d: 'M13 10H18L21 7L18 4H13V2H11V4H4V10H11V12H6L3 15L6 18H11V22H13V18H20V12H13V10Z',
      key: '1b1r7v',
    },
  ],
]);

export default Signpost;
